module.exports = __webpack_public_path__ + "static/media/malt-l.6bb1baaf.mp3";